import { useQuery } from "@tanstack/react-query";

import { integrationsApi } from "../api/integrations.api";

// Query key factory for integration module
export const integrationModuleKeys = {
  all: ['integrationModule'] as const,
  byIntegration: (integrationName: string) => [...integrationModuleKeys.all, integrationName] as const,
  byModule: (integrationName: string, moduleName: string) =>
    [...integrationModuleKeys.byIntegration(integrationName), moduleName] as const,
  detail: (integrationName: string, moduleName: string, tenantId?: string, clientId?: string) =>
    [...integrationModuleKeys.byModule(integrationName, moduleName), tenantId, clientId] as const,
} as const;

interface UseIntegrationModuleParams {
  integrationName: string;
  moduleName: string;
  tenantId?: string;
  clientId?: string;
}

export function useIntegrationModule({
  integrationName,
  moduleName,
  tenantId,
  clientId,
}: UseIntegrationModuleParams) {
  return useQuery({
    queryKey: integrationModuleKeys.detail(integrationName, moduleName, tenantId, clientId),
    queryFn: () => integrationsApi.fetchIntegrationModule(integrationName, moduleName, { tenantId, clientId }),
    enabled: !!integrationName && !!moduleName,
    staleTime: 20 * 60 * 1000,
  });
}
